import { forwardRef, useId } from 'react';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { Field } from './Field';
import { cn, inputClasses } from './utils';

export interface SelectProps extends ComponentPropsWithoutRef<'select'> {
  label?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  containerClassName?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { id, label, hint, error, required, className, containerClassName, children, ...props },
  ref,
) {
  const generatedId = useId();
  const selectId = id ?? generatedId;

  return (
    <Field
      id={selectId}
      label={label}
      hint={hint}
      error={error}
      required={required}
      className={containerClassName}
    >
      <select
        ref={ref}
        id={selectId}
        required={required}
        aria-invalid={error ? true : undefined}
        className={cn(
          inputClasses,
          'cursor-pointer pr-9',
          error && 'border-red-500 focus-visible:ring-red-500',
          className,
        )}
        {...props}
      >
        {children}
      </select>
    </Field>
  );
});
